// This takes input like '2d' or '2D' and returns [2, 'D'] (number and uppercase value)
// If the input doesn't meet the required rexeg pattern 'NNNV' (number (up to 3) value) then it returns null
export function TenorSplitter(tenor: string): [number, string] | null {
  const isValid = /^[0-9]{1,3}[dmywDMYW]{1}/.test(tenor);

  if (isValid) {
    const [number, value] = tenor.match(/\d+|[a-zA-Z]+/g);
    return [Number(number), value.toUpperCase()];
  }

  return null;
}
